import React from 'react';
import { Container, Paper, Stack, Typography } from '@mui/material';
import ProjectsPage from './ProjectsPage';

export default function MainUploadPage() {
  return (
    <Container maxWidth="lg">
      <Paper
        elevation={0}
        className="surface-glow"
        sx={{
          p: { xs: 2, md: 3 },
          borderRadius: 4,
          overflow: 'hidden',
        }}
      >
        <Stack spacing={0.75} sx={{ mb: 2.5 }}>
          <Typography variant="h4">Рабочее пространство</Typography>
          <Typography variant="body1" color="text.secondary">
            Управляйте проектами в одном месте.
          </Typography>
        </Stack>

        <ProjectsPage />
      </Paper>
    </Container>
  );
}
